const actions = {
  LOAD_CUSTOM_PROFILE: 'LOAD_CUSTOM_PROFILE',
  LOAD_CUSTOM_PROFILE_SUCCESS: 'LOAD_CUSTOM_PROFILE_SUCCESS',
  LOAD_CUSTOM_PROFILE_ERROR: 'LOAD_CUSTOM_PROFILE_ERROR',
  loadCustomProfiles: ({ limit, skip, fromDate, toDate, tags, profileType }) => ({
    type: actions.LOAD_CUSTOM_PROFILE,
    limit,
    skip,
    fromDate,
    toDate,
    tags,
    profileType
  }),
  loadCustomProfilesSuccess: (data, meta) => ({
    type: actions.LOAD_CUSTOM_PROFILE_SUCCESS,
    data,
    meta,
  }),
  loadCustomProfilesError: (error) => ({
    type: actions.LOAD_CUSTOM_PROFILE_ERROR,
    error,
  })
};

export default actions;
